module.exports = __webpack_public_path__ + "static/media/arise-frame.cb2e8572.png";